/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserFulfillmentRequest = {
  /**
   * List of preparer IDs to filter fulfillments. At least one preparer ID is required.
   */
  preparer_ids?: Array<number>;
  /**
   * List of reviewer IDs to filter fulfillments. At least one reviewer ID is required.
   */
  reviewer_ids?: Array<number>;
  /**
   * Filter by fulfillment status: 'current' for non-completed, 'past' for completed
   */
  status_filter?: UserFulfillmentRequest.status_filter;
};
export namespace UserFulfillmentRequest {
  /**
   * Filter by fulfillment status: 'current' for non-completed, 'past' for completed
   */
  export enum status_filter {
    CURRENT = 'current',
    PAST = 'past',
  }
}
